import React, { PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import cx from 'classnames';

const getRefTechName = worker => `${worker.display_name}`;

const renderDefault = () => <div className="default text">Commercial</div>;

const renderWorker = worker => (
  <div key={worker.id} data-value={worker.id} className="item">
    {getRefTechName(worker)}
  </div>
);

export const WorkerDropdown = ({
  workerId,
  workers,
  hasError,
  onChange,
  canDelete,
  readOnly,
}) => {
  const fieldClassName = cx('five wide field', {
    error: hasError,
  });

  return (
    <div className={fieldClassName}>
      <label>Commercial</label>
      <Dropdown
        name="worker_id"
        value={workerId}
        canDelete={canDelete}
        items={workers}
        renderDefault={renderDefault}
        renderItem={renderWorker}
        onChange={onChange}
        disabled={readOnly}
      />
    </div>
  );
};

WorkerDropdown.propTypes = {
  workerId: PropTypes.number,
  workers: PropTypes.array.isRequired,
  hasError: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default WorkerDropdown;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/components/WorkerDropdown.js